// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { Color } from '../../../Graphics';
import { PriceType } from '@shared/utils/History/CashItemUtils';
import { IndicatorScriptBase } from '../IndicatorScriptBase';
import { LineStyle } from '../IndicatorScriptBaseEnums';
import { InputParameterInteger } from '../InputParamaterClasses/InputParameterInteger';
export class PPMA extends IndicatorScriptBase {
    constructor() {
        super();
        // #region Initialization
        this.ProjectName = 'Pivot Point Moving Average';
        this.Comments = 'Uses the pivot point calculation as the input a simple moving average';
        // #endregion
        this.SetIndicatorLine('PPMA', Color.Blue, 1, LineStyle.SimpleChart);
        this.SetIndicatorLine('PPMA_MA', Color.Yellow, 1, LineStyle.SimpleChart);
        this.SeparateWindow = false;
        this.PPMAPeriod = 5;
        super.InputParameter(new InputParameterInteger('PPMAPeriod', 'PPMA Period:', 0, 1, 100, 0, 1));
    }
    Init() {
        this.IndicatorShortName(this.GetIndicatorShortName());
        this.UpdateIndexDrawBegin();
    }
    GetIndicatorShortName() {
        return 'PPMA(' + this.PPMAPeriod + ')';
    }
    getCustomName() {
        return 'PPMA (' + this.ProjectName + ')';
    }
    UpdateIndexDrawBegin() {
        this.SetIndexDrawBegin(0, this.PPMAPeriod);
        this.SetIndexDrawBegin(1, this.PPMAPeriod);
    }
    OnQuote() {
        super.OnQuote();
        if (this.CurrentData.Count < this.PPMAPeriod) {
            return;
        }
        const pivot = (this.CurrentData.getPriceByType(PriceType.High, 0) +
            this.CurrentData.getPriceByType(PriceType.Low, 0) +
            this.CurrentData.getPriceByType(PriceType.Close, 0)) /
            3.0;
        this.SetValue(0, 0, pivot);
        let sum = pivot;
        for (let i = 1; i < this.PPMAPeriod; i++) {
            sum +=
                (this.CurrentData.getPriceByType(PriceType.High, i) +
                    this.CurrentData.getPriceByType(PriceType.Low, i) +
                    this.CurrentData.getPriceByType(PriceType.Low, i)) /
                    3.0;
        }
        this.SetValue(1, 0, sum / this.PPMAPeriod);
    }
}
